import React, { ReactNode, useMemo } from 'react';
import classNames from 'classnames';
import Mask from '../Mask';
import { mergeProps } from '../utils/with-default-props';
import { PropagationEvent } from '../utils/with-stop-propagation';
import { GetContainer } from '../utils/render-to-container';
import isMobile from '../../utils/isMobile';
import styles from './toast.module.scss';

export interface ToastProps {
  afterClose?: () => void;
  maskStyle?: React.CSSProperties;
  maskClassName?: string;
  maskClickable?: boolean;
  content?: ReactNode;
  duration?: number;
  position?: 'top' | 'bottom' | 'center';
  visible?: boolean;
  getContainer?: GetContainer;
  stopPropagation?: PropagationEvent[];
}

const defaultProps = {
  maskClickable: true,
  stopPropagation: ['click'],
};

export const InternalToast: React.FC<ToastProps> = p => {
  const props = mergeProps(defaultProps, p);
  const { maskClickable, content, position } = props;

  const top = useMemo(() => {
    switch (position) {
      case 'top':
        return '20%';
      case 'bottom':
        return '80%';
      default:
        return '50%';
    }
  }, [position]);

  return (
    <Mask
      visible={props.visible}
      destroyOnClose
      opacity={0}
      disableBodyScroll={!maskClickable}
      getContainer={props.getContainer}
      afterClose={props.afterClose}
      style={{
        pointerEvents: maskClickable ? 'none' : 'auto',
        ...props.maskStyle,
      }}
      className={classNames({
        [styles.toast]: true,
        [props.maskClassName]: true,
        [styles.toast_pc]: !isMobile(),
      })}
      stopPropagation={props.stopPropagation}
    >
      <div style={{ top }} className={classNames(styles.toast_wrap, styles.toast_wrap_text)}>
        {content}
      </div>
    </Mask>
  );
};
